import React, { useState, useEffect } from 'react';
import { Play, Heart, Sparkles } from 'lucide-react';
import SongMenu from '../SongMenu';

const MadeForYou = ({ playSong, likedSongs, toggleLike, user }) => {
  const [recommendations, setRecommendations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRecommendations = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/recommendations/made-for-you`,
          {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
            }
          }
        );
        if (response.ok) {
          const data = await response.json();
          setRecommendations(data);
          console.log('✅ Loaded all Made For You recommendations:', data.length);
        }
      } catch (error) {
        console.error('Failed to load recommendations:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchRecommendations();
  }, [user]);

  if (loading) {
    return (
      <div className="page-content">
        <div className="page-header">
          <h1>Made For You</h1>
          <p>Loading your personalized recommendations...</p>
        </div>
      </div>
    );
  }

  if (recommendations.length === 0) {
    return (
      <div className="page-content">
        <div className="page-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Sparkles size={32} color="#FFD700" />
            <h1>Made For You</h1>
          </div>
          <p>Start listening to songs to get personalized recommendations!</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-content">
      <div className="page-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Sparkles size={32} color="#FFD700" />
          <h1>Made For You</h1>
        </div>
        <p>Personalized recommendations based on your listening</p>
        <div style={{ display: 'flex', gap: '12px', marginTop: '16px' }}>
          <button 
            className="play-all-button"
            onClick={() => playSong(recommendations[0], recommendations)}
            style={{
              background: '#9D4EDD',
              color: 'white',
              border: 'none',
              borderRadius: '24px',
              padding: '12px 24px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: '600'
            }}
          >
            <Play size={20} fill="white" />
            Play All
          </button>
          <button 
            className="shuffle-button"
            onClick={() => {
              const shuffled = [...recommendations].sort(() => Math.random() - 0.5);
              playSong(shuffled[0], shuffled);
            }}
            style={{
              background: 'transparent',
              color: '#9D4EDD',
              border: '2px solid #9D4EDD',
              borderRadius: '24px',
              padding: '12px 24px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: '600'
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M16 3h5v5M4 20L21 3M21 16v5h-5M15 15l6 6M4 4l5 5"/>
            </svg>
            Shuffle
          </button>
        </div>
      </div>

      <section className="content-section">
        <div className="section-header">
          <h2>{recommendations.length} Songs Just For You</h2>
        </div>
        <div className="songs-grid">
          {recommendations.map(song => (
            <div key={song.id} className="song-card">
              <div className="song-card-image">
                <img src={song.albumArt || song.album_art_url} alt={song.title} />
                <SongMenu song={song} user={user} />
                <button 
                  className="play-button"
                  onClick={() => playSong(song, recommendations)}
                >
                  <Play size={20} fill="white" />
                </button>
              </div>
              <div className="song-card-content">
                <h3 className="song-title">{song.title}</h3>
                <p className="song-artist">{song.artist}</p>
                <div className="song-meta">
                  <button
                    className={`like-button ${likedSongs && Array.isArray(likedSongs) && likedSongs.includes(song.id) ? 'liked' : ''}`}
                    onClick={() => toggleLike(song.id)}
                  >
                    <Heart size={16} fill={likedSongs && Array.isArray(likedSongs) && likedSongs.includes(song.id) ? '#9D4EDD' : 'none'} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default MadeForYou;
